import axios from "axios";

export default {
    async getPerizie(isPerito: boolean, peritoID: string, userID?: string) {
        const data = new FormData();
        data.append("limit", "300");
        data.append("offset", "0");

        const statiFilter = "pratiche_assicurative_stato IN (1, 9)";
        if (isPerito) {
            const operatoreClause = `pratiche_assicurative_operatore = '${peritoID}'`;
            const whereClause = userID
                ? `(${operatoreClause} OR pratiche_assicurative_sopralluoghista = '${userID}') AND ${statiFilter}`
                : `${operatoreClause} AND ${statiFilter}`;
            data.append("where[]", whereClause);
        } else {
            data.append("where[]", `pratiche_assicurative_sopralluoghista = '${peritoID}' AND ${statiFilter}`);
        }
        //data.append("orderby", "pratiche_assicurative_data_incarico");
        data.append("orderby", "pratiche_assicurative_stato = '1', pratiche_assicurative_stato = '9'");
        data.append("orderdir", "desc");
        data.append("depth", "2");

        //const response = await axios.post(`http://192.168.11.140/firegui_assitech/rest/v1/search/pratiche_assicurative`, data, {
        const response = await axios.post("rest/v1/search/pratiche_assicurative", data, {
            headers: {
                Authorization: process.env.VUE_APP_TOKEN,
            },
        });
        //console.log(response);
        return response;
    },

    async salvaFotoRapportino(immagini, fotoObj, perizia, stato_perizia) {
        const data = new FormData();
        data.append("perizia_id", perizia);
        data.append("fotoObj", fotoObj);
        data.append("immagini", JSON.stringify(immagini));
        // Dato che lo stato viene impostato come ultimo, sarà su chiiamata a parte
        if (stato_perizia) {
            data.append("stato", stato_perizia);
        }

        //const response = await axios.post(`http://192.168.11.140/firegui_assitech/custom/app/caricaImmagini`, data);
        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}custom/app/caricaImmagini`, data);
        //console.log(response);
        return response;
    },

    async getStatiPerizie() {
        const response = await axios.get("rest/v1/search/tipologie_stati", {
            headers: {
                Authorization: process.env.VUE_APP_TOKEN,
            },
        });
        //console.log(response);
        return response;
    },

    async salvaDisegni(praticaId: string, disegni: string) {
        const data = new FormData();
        data.append("perizia_id", praticaId);
        data.append("disegni", disegni);

        //const response = await axios.post(`http://192.168.11.140/firegui_assitech/custom/app/caricaDisegni`, data);
        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}custom/app/caricaDisegni`, data);
        //console.log(response);
        return response;
    },

    async salvaStatoPerizia(perizia_id, stato, user_id) {
        const data = new FormData();
        data.append("perizia_id", perizia_id);
        data.append("stato", stato);
        data.append("user_id", user_id);

        //const response = await axios.post(`http://192.168.11.140/firegui_assitech/custom/app/salvaStatoPerizia`, data);
        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}custom/app/salvaStatoPerizia`, data);
        //console.log(response);
        return response;
    },

    async salvaFirmaPrivacy(perizia_id, firma) {
        const data = new FormData();
        data.append("perizia_id", perizia_id);
        data.append("firma_privacy", firma);

        //const response = await axios.post(`http://192.168.11.140/firegui_assitech/custom/app/salva_modulo_privacy`, data);
        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}custom/app/salva_modulo_privacy`, data);
        //console.log(response);
        return response;
    },

    async salvaStoricoStep(perizia_id: string, step: string) {
        const data = new FormData();
        data.append("pratica_id", perizia_id);
        data.append("step", step);

        //const response = await axios.post(`http://192.168.11.140/firegui_assitech/custom/app/update_compilazione_step_post`, data);
        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}custom/app/update_compilazione_step_post`, data);
        //console.log(response);
        return response;
    },

    async getStoricoCompilazione(perizia_id: string) {
        const data = new FormData();
        data.append("where[]", `compilazione_pratiche_pratica_id = '${perizia_id}'`);
        data.append("limit", "1");
        data.append("offset", "0");

        //const response = await axios.post(`http://192.168.11.140/firegui_assitech/rest/v1/search/compilazione_pratiche`, data, {
        const response = await axios.post("rest/v1/search/compilazione_pratiche", data, {
            headers: {
                Authorization: process.env.VUE_APP_TOKEN,
            },
        });
        //console.log(response);
        return response;
    },
};
